import { render, staticRenderFns } from "./GeneralDetails.vue?vue&type=template&id=9c16c522&scoped=true&"
import script from "./GeneralDetails.vue?vue&type=script&lang=js&"
export * from "./GeneralDetails.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/form.css?vue&type=style&index=0&id=9c16c522&scoped=true&lang=css&"
import style1 from "./GeneralDetails.vue?vue&type=style&index=1&id=9c16c522&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c16c522",
  null
  
)

export default component.exports